import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  dialogbox: {
    padding: "16px 0",
  },
  lightText: {
    "& .MuiTypography-root": {
      color: "rgba(0, 0, 0, 0.7)",
    },
  },
}));

export default useStyles;
